<div class="document-lists-block mb-4 fs-16" *ngIf="documents.length > 0">
    <p class="select-label mb-1 doc-name-upload-doc">
        {{ documents.length === 1 ? "Document" : "Documents" }}
    </p>
    <ng-container *ngIf="documents.length > 1">
        <span class="docs-header"> {{ 'Document name' }} </span>
    </ng-container>

    <ul class="list-group list-group-light">
        <li class="height-56" *ngFor="let file of documents; let i = index"
            [ngClass]="{'back-col-E8EBED': documents.length === 1,
                'back-col-F5F6F7 col-2d373d':  documents.length > 1 && i % 2 === 1 }">
        <span class="doc-name" [ngClass]="{'pl-3': documents.length === 1}"> 
            <ng-container *ngIf="documents.length > 1">
                <span class="doc-series"> {{ i + 1 }} </span>
            </ng-container>
            {{ file.name }}
            </span>
        <span class="edit-delete">
            <span (click)="deleteFile(file, $event, i)">
            <img src="./assets/img/images/icon-delete.svg" alt="delete icon" />               
            </span>
        </span>
        </li>
    </ul>
</div>

<input type="file" class="d-none upload-file"
    (change)="uploadFile($event)" #fileUpload>

<div class="upload-file margin-bottom mb24">
    <mapfre-button
        btnId ="upload-documents-request"
        inputType ="upload-button"
        (click)="openFileDialog()"
        additionalClasses="ghost primary x-small-btn uploadDocBtn height-56"
        [translateValue]="'UPLOAD_DOCS' | translate">
    </mapfre-button>
    <p class="select-label mb-0 mt-2">{{ "(Max. size 20MB per file)" }}</p>
</div>

<ng-container *ngIf="showTooLargeFileModal">
    <mapfre-modal
      [modalOptions]="uploadFilesModal"
      [hideModal]="hideModal"
      (click)="resetHideModal()"
      (closeModal)="resetHideModal()"
    >
      <div class="modal-docs-content modal-body no-margin-top">  
        <div class="modal-block margin-top mt16 text-center pb-4">
            <figure>
              <img src='./assets/img/images/icon-warning.svg' alt="warning icon" />
            </figure>
            <div class="bigger-font-size margin-top mt16">
              <div> {{ 'FILE_TOO_LARGE' | translate }} </div>
            </div>
            <div class="margin-top mt16 col-2d373d fs-16 lh-normal">
              {{ "FILES_LARGER_THAN_20MB" | translate }}
            </div>
        </div>

        <hr class="mt-2 mb-2 col-E8EBED" />

        <div class="row text-right pt-4">
            <div class="col show-btn-order">
                <mapfre-button [additionalClasses]="'ghost secondary small-btn modal-small-btn no-border mt-0 mr-0'"
                    [iconClasses]="'align-middle'" (click)="resetHideModal()">
                    {{ 'BACK' | translate }}
                </mapfre-button>
              <mapfre-button [ngClass]="{'custom_loader':loader}" 
                [additionalClasses]="'basic primary small-btn modal-small-btn'"
                (click)="openFileDialog()">
                {{ 'TRY_AGAIN' | translate }}</mapfre-button>
            </div>
        </div>
      </div>
    </mapfre-modal>
  </ng-container>

  <app-leave-page-modal
    *ngIf="showLeaveModal"
      (isLeavingPage)="leavePage($event)">
    </app-leave-page-modal>

  <ng-container *ngIf="showDeleteFileModal">
    <mapfre-modal
      [modalOptions]="uploadFilesModal"
      [hideModal]="hideModal"
      (click)="resetHideModal()"
      (closeModal)="resetHideModal()"
    >
      <div class="modal-docs-content modal-body no-margin-top">  
        <div class="modal-block margin-top mt16 text-center pb-4">
            <figure>
              <img src='./assets/img/images/icon-delete-526570.svg' alt="icon delete" />
            </figure>
            <div class="bigger-font-size margin-top mt16">
              <div> {{ 'REMOVE_FILE' | translate }} </div>
            </div>
            <div class="margin-top mt16 col-2d373d fs-16 lh-normal">
              {{ "YOU_SURE_REMOVE" | translate }} {{documents[indxFiletoDelete].name}}?
            </div>
        </div>

        <hr class="mt-2 mb-2 col-E8EBED" />

        <div class="row text-right pt-4">
            <div class="col show-btn-order">
                <mapfre-button [additionalClasses]="'ghost secondary small-btn modal-small-btn no-border mt-0 mr-0'"
                    [iconClasses]="'align-middle'" (click)="cancelDeleteFile()">
                    {{ 'CANCEL' | translate }}
                </mapfre-button>
              <mapfre-button [ngClass]="{'custom_loader':loader}" 
                [additionalClasses]="'basic primary small-btn modal-small-btn'"
                (click)="confirmDeleteFile()">
                {{ 'CONFIRM_BUTTON' | translate }}</mapfre-button>
            </div>
        </div>
      </div>
    </mapfre-modal>
  </ng-container>
